import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

export default function AdminLogin() {
    const { signIn } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await signIn(email, password);
            navigate("/admin");
        } catch (e) {
            const d = e?.response?.data?.detail;
            setErr(typeof d === "string" ? d : "Login fehlgeschlagen");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen flex items-center justify-center px-6 bg-[var(--rb-bg)]"
            data-testid="admin-login-page"
        >
            <motion.form
                onSubmit={submit}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="glass w-full max-w-md p-10"
            >
                <Link
                    to="/"
                    className="text-xs uppercase tracking-[0.32em] text-zinc-500 hover:text-white transition"
                >
                    ← Zurück
                </Link>
                <div className="mt-6 flex items-center gap-3 text-[var(--rb-primary)]">
                    <Lock className="w-5 h-5" />
                    <span className="text-xs uppercase tracking-[0.32em]">Admin Bereich</span>
                </div>
                <h1 className="font-display text-4xl md:text-5xl text-white mt-4 uppercase">Login</h1>

                <div className="mt-8 space-y-4">
                    <div>
                        <label className="block text-[10px] uppercase tracking-[0.32em] text-zinc-500 mb-2">
                            E-Mail
                        </label>
                        <input
                            data-testid="login-email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full bg-black/40 border border-white/10 px-4 py-3 text-white outline-none focus:border-[var(--rb-primary)] transition"
                        />
                    </div>
                    <div>
                        <label className="block text-[10px] uppercase tracking-[0.32em] text-zinc-500 mb-2">
                            Passwort
                        </label>
                        <input
                            data-testid="login-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full bg-black/40 border border-white/10 px-4 py-3 text-white outline-none focus:border-[var(--rb-primary)] transition"
                        />
                    </div>
                </div>

                {err && (
                    <div data-testid="login-error" className="mt-4 text-sm text-[#ff8b8b]">
                        {err}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading}
                    data-testid="login-submit"
                    className="mt-8 w-full bg-[var(--rb-primary)] hover:bg-[var(--rb-primary-hover)] text-black uppercase tracking-[0.28em] text-sm py-3 transition-all hover:-translate-y-0.5 disabled:opacity-60"
                >
                    {loading ? "…" : "Anmelden"}
                </button>
            </motion.form>
        </div>
    );
}
